import { Feature, Point } from '@turf/turf';
import * as turf from '@turf/turf';

// TODO: get into meraki pkg
export interface IExtent {
    xmin: number;
    xmax: number;
    ymin: number;
    ymax: number;
}

export class ExtentPadder {
    pad = ({ extent, xMeters, yMeters }: { extent: IExtent, xMeters: number, yMeters: number }): IExtent => {
        const topLeftPointFeature: Feature<Point> = {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: [extent.xmin, extent.ymax]
            }
        };
        // TODO: we are translating in the wrong direction
        // next steps, create a viewport like the phone (tall and skinny)
        // padd y more than x
        // add unit test
        // validate the output in geojson.io (should still taller and skinnier)
        turf.transformTranslate(topLeftPointFeature, xMeters, 0, { units: 'meters', mutate: true });
        turf.transformTranslate(topLeftPointFeature, yMeters, 270, { units: 'meters', mutate: true });

        const bottomRightFeature: Feature<Point> = {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: [extent.xmax, extent.ymin]
            }
        };
        turf.transformTranslate(bottomRightFeature, xMeters, 180, { units: 'meters', mutate: true });
        turf.transformTranslate(bottomRightFeature, yMeters, 90, { units: 'meters', mutate: true });

        return  {
            xmin: topLeftPointFeature.geometry.coordinates[0],
            ymin: topLeftPointFeature.geometry.coordinates[1],
            xmax: bottomRightFeature.geometry.coordinates[0],
            ymax: bottomRightFeature.geometry.coordinates[1],
        };
    }
}
